// extracted by mini-css-extract-plugin
export var imageWrapper = "fullWidthImage-module--imageWrapper--f9faa";
export var mainImage = "fullWidthImage-module--mainImage--72ee6";
export var mobileImage = "fullWidthImage-module--mobileImage--36c9c";